import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { IAppRootState } from 'src/app/core/store';

import { gridOriginalReducer } from './grid.reducer';
import { GridOriginalSliceState, GridSliceKey } from './grid.state';

export const GridFeatureKey = 'Grid';
export interface GridFeatureState {
	[GridSliceKey]: GridOriginalSliceState;
}

export interface GridRootState extends IAppRootState {
	[GridFeatureKey]: GridFeatureState;
}

export const featureSelector =
	createFeatureSelector<GridFeatureState>(GridFeatureKey);

export const gridReducers: ActionReducerMap<GridFeatureState> = {
	[GridSliceKey]: gridOriginalReducer,
};
